module.exports = __webpack_public_path__ + "static/037613ca.01.gif";